import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Landing } from './app/templates/landing/landing';
import { Notfound } from './app/templates/notfound/notfound';
import { authorizedGuard } from 'app/core/guards/authorized.guard';
import { NoPermissions } from 'app/templates/no-perm/no-perm';

export const appRoutes: Routes = [
	{ path: '', loadChildren: () => import('./app/pages/auth/auth.routes') },
	{
		path: '',
		component: AppLayout,
		canActivateChild: [authorizedGuard],
		children: [
			{ path: '', redirectTo: 'dashboard', pathMatch: 'full' },
			{ path: 'employee', loadChildren: () => import('./app/pages/employee/employee.routes') },
			{ path: 'payroll-review-approval', loadChildren: () => import('./app/pages/review-approval/page.routes') },
			{ path: 'payroll-processing', loadChildren: () => import('./app/pages/processing/pages.routes') },
			{ path: 'maintenance', loadChildren: () => import('./app/pages/maintenance/page.routes') },
			{ path: 'announcement', loadChildren: () => import('./app/pages/announcement/announcement.routes') },
			{ path: 'dashboard', loadChildren: () => import('./app/pages/dashboard/page.routes') },
			{ path: 'report', loadChildren: () => import('./app/pages/report/page.routes') },
		]
	},
	{ path: 'landing', component: Landing },
	{ path: 'no-permission', component: NoPermissions },
	{ path: 'notfound', component: Notfound },
	{ path: '**', redirectTo: '/notfound' }
];
